import { chakra, ChakraProvider, ColorModeScript, theme, useColorMode, useColorModeValue, useStyleConfig } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import './index.css';


const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);


theme.styles.global = {
  body: {
    bg: '#0f1318',
    color: '#e7e8e8',
    fontcolor: '#e7e8e8',
  },
  button: {
    bg: '#0f1318',
    color: '#e7e8e8',
    fontcolor: '#e7e8e8',
  }
};


root.render(
  <StrictMode>
    <ChakraProvider theme={theme}>
    <ColorModeScript />
    <BrowserRouter>
    <App />
    </BrowserRouter>
    </ChakraProvider>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
